import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#951D1D',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E1C0C0',
    },
  },
  typography: {
    fontSize: 14,
  },

  components: {
    // Name of the component
    MuiAccordionSummary: {
      styleOverrides: {
        // Name of the slot
        content: {
          // Some CSS
          width: '100%',
        },
      },
    },
  },
});
